import React from 'react';
import {connect} from 'react-redux'
import { Route, Switch} from 'react-router';
import { withRouter } from 'react-router-dom'
import Posts from './Posts'
import Questions from './Questions'
import {Flex, Arrow} from '/app/src/component';
import { history } from '/app/src/store';

import {FeedbackModel} from '/app/src/model'

import Theme from '/app/src/theme';
import style from './style.css'

import SVG from 'react-inlinesvg';

class Feedback extends React.Component {

    constructor(props){
        super(props)

        this.state = {
            nbrUnread: 0
        }

        this.getNbrUnread = this.getNbrUnread.bind(this);
    }

    componentDidMount() {
        this.props.getUnread('helpdesk', this.getNbrUnread);
    }

    getNbrUnread(nbrUnread){
        if(this.state.nbrUnread !== nbrUnread && nbrUnread < 100){
            this.setState({
                nbrUnread: nbrUnread
            })
        }
    }

    _navButton(buttonIdx) {
        const {currentPath} = this.props
        const {nbrUnread} = this.state;
        let tempBtn = null;
        switch(buttonIdx) {
            case 0:
                const inboxIcon = <SVG style={{fill: Theme.colors.black}} className={style.Icon} src='/images/FeedbackInbox_M.svg' cacheGetRequests={true}/>

                tempBtn = (
                    <Flex bg={ currentPath === 'posts' ? 'lightblue' : 'grey1' }
                        borderColor={currentPath === 'posts' ? 'darkblue' : 'grey1'}
                        className={style.NavButton}
                        onClick={() => {history.push('/clientChat/faq/helpdesk/feedback/posts')}}>
                        <Flex center>
                            {inboxIcon}
                            {'Inkorg'}
                            {nbrUnread > 0 &&
                                <Flex center className={style.NumberUnread}>
                                    {nbrUnread}
                                 </Flex>
                            }
                        </Flex>
                    </Flex>
                )
                break;
            case 1:
            default:
                const questionIcon = <SVG style={{fill: Theme.colors.black}} className={style.Icon} src='/images/QuestionsList_M.svg' cacheGetRequests={true}/>

                tempBtn = (
                    <Flex bg={ currentPath === 'questions' ? 'blue1' : 'grey1' }
                        borderColor={ currentPath === 'questions' ? 'darkblue' : 'grey1' }
                        className={style.NavButton}
                        onClick={() => {history.push('/clientChat/faq/helpdesk/feedback/questions')}}>
                        <Flex center> {questionIcon} Frågor </Flex>
                    </Flex>
                )
        }
        return tempBtn;
    }

    _renderNavigation() {
        return (
            <Flex width='300px' bg={'grey1'} mt='30px' mb='10px' className={style.NavContainer} shrink={0}>
                <Flex grow>
                {this._navButton(0)}
                </Flex>
                <Flex>
                {this._navButton(1)}
                </Flex>
            </Flex>
        )
    }

    render() {
        const BackArrowButton = {
            onClick: (e)=>{
                e.stopPropagation();
                history.push('/clientChat/faq/helpdesk/categories/')
            },
            text: 'Tillbaka till Helpdesk',
            direction: 'left',
            color: 'grey',
            hover: 'blue',
        }

        return (
            <Flex w='100%' column shrink={0}>
                <Flex color={'lightblack'} shrink={0} className={style.BackNav}>
                    <Arrow {...BackArrowButton}/>
                </Flex>
                <Flex center w='100%' shrink={0}>
                    {this._renderNavigation()}
                </Flex>
                <Switch>
                    <Route path='/clientChat/faq/helpdesk/feedback/posts' component={Posts}/>
                    <Route path='/clientChat/faq/helpdesk/feedback/questions' component={Questions}/>
                </Switch>
            </Flex>
        )
    }
}

const {dispatcher: dispatchFeedback} = FeedbackModel.read();
const {dispatcher: getUnread} = FeedbackModel.getUnread();

const mapDispatchToProps = (dispatch, props) => {
    return {
        'dispatchFeedback': (systemType, index) => dispatch(dispatchFeedback(systemType, index)),
        'getUnread': (systemType, callback) => dispatch(getUnread(systemType, callback))
    }
}

function mapStateToProps(state, ownProps) {
    const path = ownProps.history.location.pathname.split('/')
    return {
        currentPath: path[path.length-1]
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Feedback))



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/index.js